import { render, staticRenderFns } from "./ModuleCreator.vue?vue&type=template&id=cb778800&"
import script from "./ModuleCreator.vue?vue&type=script&lang=js&"
export * from "./ModuleCreator.vue?vue&type=script&lang=js&"
import style0 from "./ModuleCreator.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports